var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"form__button",attrs:{"type":"submit","value":_vm.$t(_vm.value),"disabled":_vm.loading}},[(_vm.loading && _vm.hasLoader)?_c('i',{staticClass:"fa fa-spin fa-1x fa-spinner"}):_vm._e(),_vm._v(" "+_vm._s(_vm.loading ? " " : _vm.$t(_vm.value))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }